import { BaseModal } from './BaseModal'

type Props = {
    isOpen: boolean
    handleClose: () => void
}

export const BantumiPromoModal = ({ isOpen, handleClose }: Props) => {
    return (
        <BaseModal title="Próbáld ki a Bantumit!" isOpen={isOpen} handleClose={handleClose}>
            <div className="flex flex-col items-center gap-4 py-2">
                <p className="text-sm text-gray-600 dark:text-slate-300 text-center">
                    A <strong>Bantumi</strong> egy ősi afrikai kőrakó stratégiai játék – kövesd a köveket,
                    gyűjts többet az ellenfelednél, és győzz! Játssz bot ellen vagy online barátaid ellen.
                </p>
                <div className="flex flex-col items-center gap-1 w-full">
                    <img src="http://bantumi.hu/manifest/icon-96x96.png" alt="Bantumi" className="w-16 h-16" />
                    <p className="text-xs text-gray-400 dark:text-slate-400">Bantumi – a kőrakós stratégiai játék</p>
                </div>
                <a
                    href="https://bantumi.hu"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center px-6 py-3 bg-yellow-600 hover:bg-yellow-500 text-white font-bold rounded-xl transition-all duration-200 shadow-md hover:shadow-lg text-sm"
                >
                    Játssz a Bantumival! →
                </a>
                <button
                    onClick={handleClose}
                    className="text-xs text-gray-400 hover:text-gray-600 dark:text-slate-500 dark:hover:text-slate-300 transition-colors"
                >
                    Bezárás
                </button>
            </div>
        </BaseModal>
    )
}
